// extracted by mini-css-extract-plugin
module.exports = {"forgot_password_container":"LoginFieldSet_forgot_password_container__2Y24V","forgot_password_link":"LoginFieldSet_forgot_password_link__1bmN2"};